export const shopSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 40,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 511,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 11],
                  [179, 3],
                  [192, 0],
                  [205, 3],
                  [216, 11],
                  [287, 108],
                  [341, 194],
                  [373, 264],
                  [381, 294],
                  [384, 319],
                  [380, 356],
                  [369, 392],
                  [352, 425],
                  [328, 454],
                  [299, 478],
                  [265, 496],
                  [229, 507],
                  [192, 511],
                  [155, 507],
                  [119, 496],
                  [85, 478],
                  [56, 454],
                  [32, 425],
                  [15, 392],
                  [4, 356],
                  [0, 319],
                  [3, 294],
                  [11, 264],
                  [43, 194],
                  [97, 108],
                  [168, 11],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [234, 67, 53, 255],
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [277.2, 335.7],
                  [282.9, 337.1],
                  [287, 340.9],
                  [288.7, 346.9],
                  [286.8, 353],
                  [264, 387.2],
                  [258.8, 392],
                  [251.9, 393.7],
                  [132.1, 393.7],
                  [125.3, 392],
                  [120, 387.2],
                  [97.2, 353],
                  [95.3, 346.8],
                  [96, 343.1],
                  [97.8, 339.8],
                  [100.7, 337.3],
                  [104.2, 335.9],
                  [106.5, 335.7],
                  [277.2, 335.7],
                ],
                [
                  [106.5, 335.7],
                  [106.4, 335.7],
                  [106.5, 335.7],
                  [106.5, 335.7],
                ],
                [
                  [258.9, 238.8],
                  [262.7, 239.4],
                  [266, 241.4],
                  [268.2, 244.6],
                  [269, 248.4],
                  [269, 325.7],
                  [250, 325.7],
                  [250, 325.7],
                  [250, 248.7],
                  [250.7, 245],
                  [252.6, 241.9],
                  [255.5, 239.7],
                  [258.9, 238.8],
                ],
                [
                  [197.5, 238.7],
                  [203, 239.8],
                  [207.7, 242.9],
                  [210.9, 247.6],
                  [212, 253.2],
                  [212, 325.7],
                  [192, 325.7],
                  [192, 277.7],
                  [134, 277.7],
                  [134, 325.7],
                  [115, 325.7],
                  [115, 253.2],
                  [116.1, 247.6],
                  [119.2, 242.9],
                  [123.9, 239.8],
                  [129.5, 238.7],
                  [197.5, 238.7],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 511],
                [0, 511],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});

export const desktopSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [126.1, 363.4],
                  [257.9, 363.4],
                  [257.9, 297.5],
                  [126.1, 297.5],
                  [126.1, 363.4],
                ],
                [
                  [229.7, 231.8],
                  [233.3, 232.5],
                  [236.4, 234.6],
                  [238.4, 237.6],
                  [239.1, 241.2],
                  [238.4, 244.8],
                  [236.4, 247.9],
                  [233.3, 249.9],
                  [229.7, 250.6],
                  [209.3, 250.6],
                  [206.2, 260],
                  [258, 260],
                  [265.2, 261.4],
                  [271.3, 265.5],
                  [275.4, 271.6],
                  [276.8, 278.8],
                  [276.8, 363.5],
                  [275.4, 370.7],
                  [271.3, 376.8],
                  [265.2, 380.9],
                  [258, 382.3],
                  [126.1, 382.3],
                  [118.9, 380.9],
                  [112.8, 376.8],
                  [108.7, 370.7],
                  [107.3, 363.5],
                  [107.3, 278.8],
                  [108.7, 271.6],
                  [112.8, 265.5],
                  [118.9, 261.4],
                  [126.1, 260],
                  [177.9, 260],
                  [174.8, 250.6],
                  [154.4, 250.6],
                  [150.8, 249.9],
                  [147.7, 247.9],
                  [145.7, 244.8],
                  [145, 241.2],
                  [145.7, 237.6],
                  [147.7, 234.6],
                  [150.8, 232.5],
                  [154.4, 231.8],
                  [229.7, 231.8],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});

export const thuisbezorgdSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [149.6, 232.1],
                  [159.6, 232.3],
                  [161, 233.5],
                  [160, 245.6],
                  [159, 261.6],
                  [157.7, 263.9],
                  [151.3, 269.8],
                  [148.6, 277.9],
                  [148.5, 289.5],
                  [148.9, 301.1],
                  [149.5, 321.6],
                  [150, 330],
                  [150.4, 333.5],
                  [151.4, 335],
                  [153.1, 335.6],
                  [155, 335],
                  [156, 333.4],
                  [156.2, 330.8],
                  [155.7, 322.2],
                  [155.2, 307.9],
                  [154.8, 296],
                  [155.7, 293],
                  [158.4, 291.6],
                  [161.8, 292.3],
                  [163.3, 295.3],
                  [163.5, 299.8],
                  [164.4, 325.7],
                  [165, 333],
                  [166.1, 334.9],
                  [168.2, 335.6],
                  [170.2, 334.7],
                  [170.9, 332.6],
                  [170.7, 328.9],
                  [169.8, 309.6],
                  [169.5, 295.9],
                  [170.4, 292.9],
                  [172.9, 291.6],
                  [176.2, 292.2],
                  [177.9, 295.1],
                  [178.1, 296.9],
                  [178.5, 313.2],
                  [179.6, 332.7],
                  [180.6, 334.8],
                  [182.9, 335.6],
                  [184.9, 334.5],
                  [185.6, 332.1],
                  [185.1, 325.2],
                  [184.5, 309.5],
                  [184.3, 296.7],
                  [184.2, 279.6],
                  [183.4, 274.4],
                  [180.6, 268.8],
                  [175.7, 264.4],
                  [174.5, 262.6],
                  [174.9, 253.8],
                  [175.9, 239.7],
                  [176.4, 234.1],
                  [176.9, 232.9],
                  [178.1, 232.6],
                  [183.4, 232.7],
                  [202.6, 232.6],
                  [213.4, 232.6],
                  [214.8, 233.9],
                  [215.5, 240.5],
                  [216.5, 251.7],
                  [217, 258.8],
                  [216.8, 260],
                  [215.7, 260.5],
                  [206.9, 261.6],
                  [202.7, 263.3],
                  [201.3, 267.6],
                  [201.2, 280.1],
                  [203.1, 296.2],
                  [209, 316],
                  [218.6, 334],
                  [222.9, 339.8],
                  [225.5, 341.7],
                  [228.6, 341.6],
                  [231, 340],
                  [232.1, 337.2],
                  [233, 325.8],
                  [233.6, 309.7],
                  [233.5, 289.8],
                  [233.1, 273.5],
                  [232.6, 263.2],
                  [231.6, 249.4],
                  [230.8, 240.6],
                  [230.1, 233.8],
                  [231.4, 232.3],
                  [247.4, 231.9],
                  [250.7, 233],
                  [252.4, 236.1],
                  [253.9, 247.4],
                  [255.3, 261.3],
                  [256, 272.2],
                  [256.8, 289.9],
                  [256.9, 305],
                  [257.5, 307],
                  [259.2, 307.9],
                  [271.5, 309.2],
                  [274.2, 309.5],
                  [276.5, 310.5],
                  [277.9, 312.5],
                  [278.2, 314.9],
                  [277.2, 317.4],
                  [267.3, 332.1],
                  [257.1, 345.2],
                  [254.9, 348.9],
                  [254, 353.1],
                  [253.5, 358.9],
                  [251.8, 371.8],
                  [249.2, 386.4],
                  [247.6, 389.6],
                  [244.3, 391],
                  [240.1, 391.4],
                  [229.2, 392.2],
                  [225.7, 391],
                  [224.3, 387.4],
                  [224.3, 380.7],
                  [223.5, 379],
                  [221.7, 379.4],
                  [218.5, 381.8],
                  [197.7, 395.9],
                  [192.1, 397.6],
                  [186.4, 395.9],
                  [164.4, 380.9],
                  [143.4, 362.5],
                  [127.3, 345.2],
                  [112.9, 326.3],
                  [106.8, 317.1],
                  [105.8, 314.5],
                  [106.2, 312.1],
                  [107.8, 310.3],
                  [110.4, 309.4],
                  [124.5, 307.8],
                  [126.8, 306.9],
                  [127.4, 304.5],
                  [127.8, 281],
                  [128.1, 273.8],
                  [129.1, 259.8],
                  [130, 249.7],
                  [131.6, 236.5],
                  [133.3, 232.9],
                  [136.9, 231.7],
                  [149.6, 232.1],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});

export const uberEatsSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [169.6, 240.6],
                  [163.2, 241.8],
                  [157.8, 245.3],
                  [154.1, 250.7],
                  [152.8, 257],
                  [154, 263.4],
                  [157.5, 268.8],
                  [162.9, 272.5],
                  [169.2, 273.8],
                  [175.6, 272.6],
                  [181, 269.1],
                  [184.7, 263.7],
                  [186, 257.4],
                  [186, 257.2],
                  [184.8, 250.9],
                  [181.3, 245.5],
                  [176, 241.9],
                  [169.7, 240.6],
                  [169.6, 240.6],
                ],
                [
                  [245.2, 230],
                  [245.3, 242.3],
                  [235, 242.3],
                  [231.1, 243.4],
                  [229.8, 246.6],
                  [229.8, 272],
                  [245.3, 272],
                  [245.3, 284.3],
                  [229.8, 284.3],
                  [229.8, 299.8],
                  [216, 299.8],
                  [216, 284.3],
                  [205.5, 284.3],
                  [205.5, 272],
                  [215.9, 272],
                  [215.9, 243.1],
                  [216.9, 237.8],
                  [219.9, 233.6],
                  [224.5, 230.9],
                  [230.4, 230],
                  [245.2, 230],
                ],
                [
                  [134.1, 230],
                  [134.1, 242.7],
                  [96.4, 242.7],
                  [96.4, 260.9],
                  [133, 260.9],
                  [133, 273.1],
                  [96.4, 273.1],
                  [96.4, 291],
                  [134.1, 291],
                  [134.1, 303.7],
                  [82.5, 303.7],
                  [82.5, 230],
                  [134.1, 230],
                ],
                [
                  [276.7, 228.6],
                  [286.8, 229.8],
                  [294.7, 233.5],
                  [299.8, 239.2],
                  [301.5, 246.6],
                  [300.4, 251.9],
                  [297.3, 256.3],
                  [292.2, 259.7],
                  [285.2, 262],
                  [273.5, 264.4],
                  [266.5, 266.5],
                  [264.6, 269.5],
                  [267, 273.4],
                  [273.9, 274.8],
                  [282.6, 272.9],
                  [285.1, 270.5],
                  [286.5, 267],
                  [300.2, 267],
                  [298.1, 275.1],
                  [293, 281],
                  [285.1, 284.7],
                  [274.7, 285.9],
                  [264.5, 284.7],
                  [256.8, 281.2],
                  [251.9, 275.7],
                  [250.3, 268.5],
                  [251.4, 263],
                  [254.6, 258.6],
                  [260.1, 255.2],
                  [267.8, 252.9],
                  [280.9, 249.9],
                  [285.9, 248.2],
                  [287.4, 245.4],
                  [284.7, 241.4],
                  [277.2, 239.9],
                  [267.6, 241.7],
                  [264.8, 244.1],
                  [263, 247.7],
                  [249.2, 247.7],
                  [252.2, 239.4],
                  [257.8, 233.4],
                  [266, 229.8],
                  [276.7, 228.6],
                ],
                [
                  [168.4, 228.6],
                  [177.7, 230.2],
                  [185.8, 234.9],
                  [185.8, 230],
                  [199.5, 230],
                  [199.5, 284.3],
                  [185.8, 284.4],
                  [185.8, 279.5],
                  [177.7, 284.2],
                  [168.4, 285.8],
                  [157.4, 283.9],
                  [148, 277.8],
                  [141.6, 268.7],
                  [139.2, 257.8],
                  [141.1, 246.8],
                  [147.2, 237.4],
                  [156.3, 231],
                  [167.2, 228.6],
                  [168.4, 228.6],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [224.2, 352.5],
                  [226.4, 358.1],
                  [230.1, 362.4],
                  [235, 365.2],
                  [240.5, 366.2],
                  [246, 365.2],
                  [250.9, 362.4],
                  [254.6, 358],
                  [256.7, 352.5],
                  [224.2, 352.5],
                ],
                [
                  [179.1, 329],
                  [172, 330.4],
                  [165.9, 334.4],
                  [161.9, 340.4],
                  [160.4, 347.5],
                  [161.8, 354.6],
                  [165.8, 360.7],
                  [171.8, 364.7],
                  [178.9, 366.2],
                  [186, 364.8],
                  [192.1, 360.8],
                  [196.1, 354.8],
                  [197.6, 347.7],
                  [197.6, 347.5],
                  [196.2, 340.4],
                  [192.2, 334.4],
                  [186.2, 330.4],
                  [179.1, 329],
                ],
                [
                  [285.3, 320.8],
                  [285.3, 351.3],
                  [286.1, 356.8],
                  [288.6, 361.2],
                  [292.3, 364],
                  [297.1, 365],
                  [297.1, 365],
                  [301.5, 365],
                  [301.5, 374.8],
                  [297.7, 374.8],
                  [290.5, 373.1],
                  [285.1, 367.9],
                  [285.1, 374.4],
                  [274.7, 374.4],
                  [274.7, 320.8],
                  [285.3, 320.8],
                ],
                [
                  [110.2, 319.6],
                  [120.8, 321.7],
                  [129.7, 327.8],
                  [129.7, 320.8],
                  [140.5, 320.8],
                  [140.5, 394.4],
                  [129.6, 394.4],
                  [129.6, 349],
                  [128.3, 341.3],
                  [124.5, 335],
                  [118.7, 330.9],
                  [111.5, 329.5],
                  [104.3, 330.9],
                  [98.6, 334.9],
                  [94.8, 341.1],
                  [93.5, 348.9],
                  [93.5, 394.4],
                  [82.4, 394.4],
                  [82.4, 348.4],
                  [84.4, 337],
                  [90.2, 327.7],
                  [99.1, 321.7],
                  [110.2, 319.6],
                ],
                [
                  [179.8, 319.6],
                  [190.6, 321.5],
                  [199.8, 327.4],
                  [206.1, 336.3],
                  [208.4, 347],
                  [206.5, 357.8],
                  [200.6, 367],
                  [191.7, 373.3],
                  [181, 375.6],
                  [179.9, 375.5],
                  [169.7, 373.5],
                  [160.9, 367.6],
                  [160.9, 394.4],
                  [150.3, 394.4],
                  [150.3, 320.8],
                  [160.7, 320.8],
                  [160.7, 327.6],
                  [169.5, 321.7],
                  [179.8, 319.6],
                ],
                [
                  [241.7, 319.4],
                  [248.3, 320.1],
                  [254.6, 322.3],
                  [260.2, 325.9],
                  [264.8, 330.8],
                  [257.1, 336.4],
                  [250.3, 330.6],
                  [241.6, 328.6],
                  [235.4, 329.7],
                  [229.9, 333],
                  [225.9, 337.9],
                  [223.9, 343.9],
                  [267.4, 343.9],
                  [267.5, 347.6],
                  [265.5, 358.6],
                  [259.9, 367.6],
                  [251.2, 373.5],
                  [240.7, 375.5],
                  [230.2, 373.3],
                  [221.2, 367.3],
                  [215.3, 358.3],
                  [213.3, 347.7],
                  [213.3, 347.5],
                  [215.4, 336.5],
                  [221.4, 327.5],
                  [230.6, 321.5],
                  [241.7, 319.4],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});

export const posSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [153.8, 325.1],
                  [153.9, 324.9],
                  [153.8, 324.9],
                  [153.7, 324.9],
                  [153.8, 325.1],
                ],
                [
                  [153.8, 207.5],
                  [158, 208.3],
                  [161.5, 210.7],
                  [163.9, 214.2],
                  [164.7, 218.4],
                  [164.7, 295],
                  [175.3, 298],
                  [184.2, 304.7],
                  [190, 314.1],
                  [192, 325],
                  [191.3, 331.5],
                  [180.9, 378],
                  [178.8, 381.2],
                  [175, 382.2],
                  [171.6, 380.5],
                  [170.2, 376.8],
                  [170.2, 331],
                  [169.2, 328.7],
                  [166.9, 327.7],
                  [164.6, 328.6],
                  [163.6, 330.8],
                  [159.3, 377.4],
                  [157.6, 380.9],
                  [153.9, 382.4],
                  [150.2, 380.9],
                  [148.5, 377.4],
                  [144.3, 330.8],
                  [143.2, 328.6],
                  [141, 327.7],
                  [138.7, 328.7],
                  [137.7, 331],
                  [137.4, 376.8],
                  [136, 380.4],
                  [132.5, 382.2],
                  [128.7, 381.2],
                  [126.6, 378],
                  [116.3, 331.5],
                  [115.6, 325],
                  [117.6, 314.1],
                  [123.4, 304.7],
                  [132.3, 298],
                  [142.9, 295],
                  [142.9, 218.4],
                  [143.7, 214.2],
                  [146.1, 210.7],
                  [149.6, 208.3],
                  [153.8, 207.5],
                ],
                [
                  [257.6, 207.5],
                  [261.8, 208.3],
                  [265.3, 210.7],
                  [267.7, 214.2],
                  [268.5, 218.4],
                  [268.5, 262.1],
                  [268.5, 300.3],
                  [268.5, 371.3],
                  [267.7, 375.5],
                  [265.3, 379.1],
                  [261.8, 381.5],
                  [257.6, 382.3],
                  [249.2, 380.1],
                  [240, 375.4],
                  [232.1, 369.2],
                  [225.4, 361.7],
                  [220.4, 353.3],
                  [216.8, 343.9],
                  [214.6, 333.5],
                  [213.9, 322.2],
                  [213.9, 284],
                  [215.6, 275.6],
                  [220.3, 268.5],
                  [227.4, 263.8],
                  [235.8, 262.1],
                  [246.7, 262.1],
                  [246.7, 218.4],
                  [247.5, 214.2],
                  [249.9, 210.7],
                  [253.4, 208.3],
                  [257.6, 207.5],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});
export const iosSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [192.2, 373.9],
                  [198.9, 374.3],
                  [205.5, 376.6],
                  [211.9, 380.7],
                  [217.9, 386.6],
                  [222.3, 392.9],
                  [225.3, 399.5],
                  [226.8, 406.3],
                  [226.8, 413.4],
                  [220.2, 412.2],
                  [213.4, 409.4],
                  [206.9, 405.4],
                  [201.7, 400.5],
                  [197.2, 394.4],
                  [194.1, 387.8],
                  [192.4, 381],
                  [192.2, 373.9],
                ],
                [
                  [167.3, 247.6],
                  [173.4, 248.6],
                  [187.5, 253.3],
                  [195.4, 254.2],
                  [202.5, 253.4],
                  [216.7, 248.6],
                  [223.7, 247.6],
                  [228.6, 248.4],
                  [233.7, 250.7],
                  [243.8, 259.7],
                  [253.9, 274.4],
                  [261.7, 291.8],
                  [252, 297.8],
                  [244.9, 305.7],
                  [240.3, 315.3],
                  [238.8, 325.8],
                  [239.9, 335.3],
                  [243.3, 343.7],
                  [249.1, 350.9],
                  [257.3, 357.2],
                  [251.4, 363.8],
                  [244.3, 368.7],
                  [235.8, 372],
                  [226, 373.7],
                  [214.7, 372.6],
                  [193.2, 366],
                  [172.9, 372.1],
                  [164.9, 373.3],
                  [156.2, 372.2],
                  [147.9, 369.4],
                  [140.4, 364.8],
                  [134, 358.8],
                  [128.9, 351.6],
                  [125.3, 343.3],
                  [123, 334.1],
                  [122.3, 324],
                  [123.6, 309.3],
                  [127.6, 293.9],
                  [136.2, 275.4],
                  [146.9, 259.8],
                  [152.2, 254.3],
                  [157.4, 250.5],
                  [162.4, 248.2],
                  [167.3, 247.6],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});
export const androidSymbol = (color: number[]) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [245.9, 297.8],
                  [239, 300.7],
                  [236.1, 307.6],
                  [239, 314.5],
                  [245.9, 317.4],
                  [252.8, 314.5],
                  [255.7, 307.6],
                  [252.8, 300.7],
                  [245.9, 297.8],
                ],
                [
                  [138.1, 297.8],
                  [131.2, 300.7],
                  [128.3, 307.6],
                  [131.2, 314.5],
                  [138.1, 317.4],
                  [145, 314.5],
                  [147.9, 307.6],
                  [145, 300.7],
                  [138.1, 297.8],
                ],
                [
                  [309.4, 264.3],
                  [307.2, 278.6],
                  [303.4, 292.5],
                  [297.9, 305.7],
                  [290.8, 318.2],
                  [282.3, 329.6],
                  [272.5, 339.9],
                  [261.5, 348.9],
                  [249.4, 356.5],
                  [268.9, 390.2],
                  [269.6, 393.3],
                  [267.8, 395.8],
                  [264.7, 396.5],
                  [262.2, 394.7],
                  [261.9, 394.2],
                  [242.2, 360],
                  [217.7, 368],
                  [192.1, 370.7],
                  [166.4, 368],
                  [142, 360],
                  [122.3, 394.2],
                  [120, 396.2],
                  [116.9, 396],
                  [114.9, 393.7],
                  [115.1, 390.6],
                  [115.4, 390.1],
                  [134.9, 356.4],
                  [122.8, 348.8],
                  [111.7, 339.8],
                  [101.9, 329.5],
                  [93.4, 318],
                  [86.4, 305.6],
                  [81, 292.4],
                  [77.3, 278.6],
                  [75.2, 264.3],
                  [309.4, 264.3],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});

export const courierSymbol = (
  color = [234, 67, 53, 255],
  textString = "Courier",
  daily_receipt_number = undefined,
  receiptColor = [0, 168, 255, 255],
  toBranch
) => {
  const isFallback = daily_receipt_number === 0;
  const text = isFallback ? toBranch : `#${daily_receipt_number}`;
  const textWidth = Math.max(16, text.length * (isFallback ? 6 : 8)); // Minimum width of 16, adjust multiplier as needed
  const halfWidth = textWidth / 2;

  const orderMarker = [
    {
      type: "CIMVectorMarker",
      enable: true,
      size: 11,
      colorLocked: true,
      anchorPointUnits: "Absolute",
      frame: {
        xmin: -5,
        ymin: -5,
        xmax: 5,
        ymax: 5,
      },
      markerGraphics: [
        {
          type: "CIMMarkerGraphic",
          symbol: {
            type: "CIMPolygonSymbol",
            symbolLayers: [
              {
                type: "CIMSolidFill",
                enable: true,
                color: receiptColor, // Blue background color
                outline: {
                  type: "CIMSolidLine",
                  color: [0, 0, 0, 255], // Black border color
                  width: 1,
                },
              },
            ],
          },
          geometry: {
            rings: [
              [
                [-halfWidth, -8], // Adjusted rectangle
                [halfWidth, -8],
                [halfWidth, 8],
                [-halfWidth, 8],
                [-halfWidth, -8],
              ],
            ],
          },
        },
      ],
      scaleSymbolsProportionally: true,
      respectFrame: true,
      offsetX: 10,
      offsetY: 20,
    },
    {
      type: "CIMVectorMarker",
      enable: true,
      size: 12,
      colorLocked: true,
      anchorPointUnits: "Absolute",
      frame: {
        xmin: -5,
        ymin: -5,
        xmax: 5,
        ymax: 5,
      },
      markerGraphics: [
        {
          type: "CIMMarkerGraphic",
          geometry: {
            x: 0,
            y: 0,
          },
          symbol: {
            type: "CIMTextSymbol",
            fontFamilyName: "Arial",
            fontStyleName: "Bold",
            height: 10,
            horizontalAlignment: "Center",
            offsetX: 0,
            offsetY: 5.5,
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color: [255, 255, 255, 255],
                },
              ],
            },
            verticalAlignment: "Center",
          },
          textString: text, // Dynamic number
        },
      ],
      scaleSymbolsProportionally: true,
      respectFrame: true,
      offsetX: 10,
      offsetY: 13,
    },
  ];

  return {
    type: "CIMSymbolReference",
    symbol: {
      type: "CIMPointSymbol",
      symbolLayers: [
        ...orderMarker,

        {
          type: "CIMVectorMarker",
          enable: true,
          anchorPointUnits: "Relative",
          dominantSizeAxis3D: "Z",
          size: 30,
          billboardMode3D: "FaceNearPlane",
          frame: {
            xmin: 0,
            ymin: 0,
            xmax: 384,
            ymax: 512,
          },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                rings: [
                  [
                    [168, 13],
                    [179, 4],
                    [192, 1],
                    [205, 4],
                    [216, 13],
                    [287, 109],
                    [341, 195],
                    [373, 266],
                    [381, 295],
                    [384, 320],
                    [380, 357],
                    [369, 393],
                    [352, 427],
                    [328, 456],
                    [299, 480],
                    [265, 497],
                    [229, 508],
                    [192, 512],
                    [155, 508],
                    [119, 497],
                    [85, 480],
                    [56, 456],
                    [32, 427],
                    [15, 393],
                    [4, 357],
                    [0, 320],
                    [3, 295],
                    [11, 266],
                    [43, 195],
                    [97, 109],
                    [168, 13],
                  ],
                ],
              },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: true,
                    color,
                  },
                ],
                angleAlignment: "Map",
              },
            },
            {
              type: "CIMMarkerGraphic",
              geometry: {
                rings: [
                  [
                    [210.8, 359.7],
                    [216.8, 360.9],
                    [221.8, 364.3],
                    [225.2, 369.3],
                    [226.4, 375.3],
                    [225.2, 381.3],
                    [221.8, 386.3],
                    [216.8, 389.7],
                    [210.8, 390.9],
                    [204.8, 389.7],
                    [199.8, 386.3],
                    [196.4, 381.3],
                    [195.2, 375.3],
                    [196.4, 369.3],
                    [199.8, 364.3],
                    [204.8, 360.9],
                    [210.8, 359.7],
                  ],
                  [
                    [184.8, 245.5],
                    [188.8, 246.3],
                    [192.2, 248.5],
                    [194.4, 251.9],
                    [195.2, 255.9],
                    [195.2, 297.4],
                    [194, 302.3],
                    [190.6, 306],
                    [176.7, 315.2],
                    [196.3, 330.9],
                    [209.5, 320.3],
                    [216, 318],
                    [236.8, 318],
                    [240.8, 318.8],
                    [244.2, 321],
                    [246.4, 324.4],
                    [247.2, 328.4],
                    [246.4, 332.4],
                    [244.2, 335.8],
                    [240.8, 338],
                    [236.8, 338.8],
                    [219.6, 338.8],
                    [219.6, 339],
                    [199.6, 354.8],
                    [195.1, 357.3],
                    [190, 358.2],
                    [184.9, 357.3],
                    [180.4, 354.9],
                    [153.4, 334.1],
                    [148, 327.4],
                    [146.4, 318.9],
                    [148.8, 310.6],
                    [154.8, 304.4],
                    [174.4, 291.9],
                    [174.4, 255.9],
                    [175.2, 251.9],
                    [177.4, 248.5],
                    [180.8, 246.3],
                    [184.8, 245.5],
                  ],
                  [
                    [247.1, 243],
                    [238.1, 244.8],
                    [230.5, 249.8],
                    [225.5, 257.4],
                    [223.7, 266.3],
                    [225.5, 275.2],
                    [230.6, 282.8],
                    [238.2, 287.9],
                    [247.1, 289.7],
                    [256, 287.9],
                    [263.6, 282.8],
                    [268.7, 275.2],
                    [270.5, 266.3],
                    [268.7, 257.4],
                    [263.7, 249.8],
                    [256.1, 244.8],
                    [247.1, 243],
                  ],
                  [
                    [122.6, 243],
                    [113.7, 244.8],
                    [106.1, 249.9],
                    [101, 257.4],
                    [99.2, 266.3],
                    [101, 275.2],
                    [106.1, 282.8],
                    [113.7, 287.9],
                    [122.6, 289.7],
                    [131.5, 287.9],
                    [139.1, 282.8],
                    [144.2, 275.2],
                    [146, 266.3],
                    [144.2, 257.4],
                    [139.1, 249.9],
                    [131.5, 244.8],
                    [122.6, 243],
                  ],
                  [
                    [247.1, 224.8],
                    [255.2, 225.6],
                    [263, 227.9],
                    [270.1, 231.8],
                    [276.4, 237],
                    [281.6, 243.3],
                    [285.5, 250.4],
                    [287.8, 258.2],
                    [288.6, 266.3],
                    [287.8, 274.4],
                    [285.5, 282.2],
                    [281.6, 289.3],
                    [276.4, 295.6],
                    [270.1, 300.8],
                    [263, 304.7],
                    [255.2, 307],
                    [247.1, 307.8],
                    [239, 307],
                    [231.2, 304.7],
                    [224.1, 300.8],
                    [217.8, 295.6],
                    [212.6, 289.3],
                    [208.7, 282.2],
                    [206.4, 274.4],
                    [205.6, 266.3],
                    [206.4, 258.2],
                    [208.7, 250.4],
                    [212.6, 243.3],
                    [217.8, 237],
                    [224.1, 231.8],
                    [231.2, 227.9],
                    [239, 225.6],
                    [247.1, 224.8],
                  ],
                  [
                    [122.5, 224.8],
                    [130.6, 225.6],
                    [138.4, 227.9],
                    [145.6, 231.8],
                    [151.9, 237],
                    [157.1, 243.3],
                    [160.9, 250.5],
                    [163.3, 258.2],
                    [164.1, 266.3],
                    [163.3, 274.4],
                    [161, 282.2],
                    [157.1, 289.3],
                    [151.9, 295.6],
                    [145.6, 300.8],
                    [138.5, 304.7],
                    [130.7, 307],
                    [122.6, 307.8],
                    [114.5, 307],
                    [106.7, 304.7],
                    [99.5, 300.8],
                    [93.2, 295.6],
                    [88, 289.3],
                    [84.2, 282.1],
                    [81.8, 274.4],
                    [81, 266.3],
                    [81.8, 258.2],
                    [84.1, 250.4],
                    [88, 243.3],
                    [93.2, 237],
                    [99.5, 231.8],
                    [106.6, 227.9],
                    [114.4, 225.6],
                    [122.5, 224.8],
                  ],
                ],
              },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: true,
                    color: [255, 255, 255, 255],
                  },
                ],
                angleAlignment: "Map",
              },
            },
          ],
          scaleSymbolsProportionally: true,
          respectFrame: true,
          clippingPath: {
            type: "CIMClippingPath",
            clippingType: "Intersect",
            path: {
              rings: [
                [
                  [0, 0],
                  [384, 0],
                  [384, 512],
                  [0, 512],
                  [0, 0],
                ],
              ],
            },
          },
        },
        {
          type: "CIMVectorMarker",
          enable: true,
          size: 15,
          colorLocked: true,
          anchorPointUnits: "Absolute",
          frame: {
            xmin: -5,
            ymin: -5,
            xmax: 5,
            ymax: 5,
          },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                x: 0,
                y: 0,
              },
              symbol: {
                type: "CIMTextSymbol",
                fontFamilyName: "Arial",
                fontStyleName: "Bold",
                height: 10,
                horizontalAlignment: "Center",
                offsetX: 0,
                offsetY: 5.5,
                symbol: {
                  type: "CIMPolygonSymbol",
                  symbolLayers: [
                    {
                      type: "CIMSolidFill",
                      enable: true,
                      color: [0, 0, 0, 255],
                    },
                  ],
                },
                verticalAlignment: "Center",
              },
              textString,
            },
          ],
          scaleSymbolsProportionally: true,
          respectFrame: true,
          offsetX: 0,
          offsetY: -35,
        },
      ],
    },
  };
};

export const RecieptSymbol = (
  dailyReceiptNumber: string,
  color: number[],
  isSelected
) => ({
  type: "CIMSymbolReference",
  symbol: {
    type: "CIMPointSymbol",
    symbolLayers: [
      {
        type: "CIMVectorMarker",
        enable: true,
        size: 14,
        colorLocked: true,
        anchorPointUnits: "Relative",
        frame: {
          xmin: -5,
          ymin: -5,
          xmax: 5,
          ymax: 5,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              x: 0,
              y: 0,
            },
            symbol: {
              type: "CIMTextSymbol",
              fontFamilyName: "Arial",
              fontStyleName: "Bold",
              height: 10,
              horizontalAlignment: "Center",
              offsetX: 0,
              offsetY: 5.5,
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: true,
                    color: [255, 255, 255, isSelected ? 255 : 50],
                  },
                ],
              },
              verticalAlignment: "Center",
            },
            textString: dailyReceiptNumber,
          },
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        offsetX: 0,
        offsetY: -5,
      },
      {
        type: "CIMVectorMarker",
        enable: true,
        anchorPointUnits: "Relative",
        dominantSizeAxis3D: "Z",
        size: 30,
        billboardMode3D: "FaceNearPlane",
        frame: {
          xmin: 0,
          ymin: 0,
          xmax: 384,
          ymax: 512,
        },
        markerGraphics: [
          {
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [
                [
                  [168, 13],
                  [179, 4],
                  [192, 1],
                  [205, 4],
                  [216, 13],
                  [287, 109],
                  [341, 195],
                  [373, 266],
                  [381, 295],
                  [384, 320],
                  [380, 357],
                  [369, 393],
                  [352, 427],
                  [328, 456],
                  [299, 480],
                  [265, 497],
                  [229, 508],
                  [192, 512],
                  [155, 508],
                  [119, 497],
                  [85, 480],
                  [56, 456],
                  [32, 427],
                  [15, 393],
                  [4, 357],
                  [0, 320],
                  [3, 295],
                  [11, 266],
                  [43, 195],
                  [97, 109],
                  [168, 13],
                ],
              ],
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidFill",
                  enable: true,
                  color,
                },
              ],
            },
          },
          // Text layer for dailyReceiptNumber
        ],
        scaleSymbolsProportionally: true,
        respectFrame: true,
        clippingPath: {
          type: "CIMClippingPath",
          clippingType: "Intersect",
          path: {
            rings: [
              [
                [0, 0],
                [384, 0],
                [384, 512],
                [0, 512],
                [0, 0],
              ],
            ],
          },
        },
      },
    ],
  },
});
